// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const PlayCircleFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M48 87.5C26.185 87.5 8.5 69.815 8.5 48S26.185 8.5 48 8.5 87.5 26.185 87.5 48 69.815 87.5 48 87.5Zm19.473-39.284a3.897 3.897 0 0 0-1.973-3.4L40.448 30.521a3.998 3.998 0 0 0-3.935-.007 3.9 3.9 0 0 0-1.986 3.385v28.202a3.9 3.9 0 0 0 1.966 3.372 3.991 3.991 0 0 0 3.914.028L65.46 51.594a3.901 3.901 0 0 0 2.014-3.378Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default PlayCircleFilled;
